import { schema, types } from 'papr'

export const userNodeSchema = schema(
	{
		user: types.objectId({ required: true }),
		node: types.objectId({ required: true }),
		bookmarked: types.boolean(),
		dateAdded: types.date(),
	},
	{
		defaults: {
			bookmarked: false,
		},
	},
)

export type UserNodeDocument = (typeof userNodeSchema)[0]
export type UserNodeDefaults = (typeof userNodeSchema)[1]
